<template>
  <div class="book-now-debug-bar">
    <span
      >Book Now: <strong>{{ label }}</strong></span
    >
    <span class="book-now-debug-bar__actions">
      <button
        type="button"
        :aria-pressed="variant === 'control'"
        @click="setVariant('control')"
      >
        control
      </button>
      <button
        type="button"
        :aria-pressed="variant === 'variation'"
        @click="setVariant('variation')"
      >
        variation
      </button>
    </span>
  </div>
</template>

<script setup lang="ts">
// Dev-only helper (rendered only outside production, see app.vue) that surfaces
// the current "Book Now" bucket and lets you flip it without VWO. Developer
// tooling, so the copy stays in English. (KFT-3914)
const { variant, isVariation, setVariant } = useBookNowExperiment()

const label = computed(() => {
  if (variant.value) return variant.value
  return isVariation.value ? 'variation (forced)' : 'not set (control)'
})
</script>

<style scoped>
.book-now-debug-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 4px 12px;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: #fff;
  background: #7c3aed;
  box-shadow: 0 1px 4px rgb(0 0 0 / 25%);
}

.book-now-debug-bar__actions {
  display: inline-flex;
  gap: 6px;
}

.book-now-debug-bar button {
  cursor: pointer;
  padding: 1px 8px;
  font: inherit;
  color: #fff;
  background: rgb(255 255 255 / 15%);
  border: 1px solid rgb(255 255 255 / 40%);
  border-radius: 4px;
}

.book-now-debug-bar button:hover {
  background: rgb(255 255 255 / 30%);
}
</style>
